<template>
    <b-col cols=12 lg=6 class='mb-5 pt-2'>
        <div class='card pt-2 pb-4 mt-2'>
            <h5 class="text-center txt-color-secondary pt-4 pb-4">Staking <b>{{this.type ==='team' ? 'Team' : ''}}</b></h5>
            <b-container>
                <b-row>
                    <b-col cols=12>
                        <div class= "pie-chart">
                            <div class='icon-circle'>
                                <div class='icon'>
                                    <div class='wraper'>
                                        <SmartGlobalIcon
                                            v-bind="{width: 25,height: 25,fill: '#212529'}"
                                        />
                                    </div>
                                </div>
                            </div>
                            <canvas id="myCanvas" width="200" height="200"/>
                        </div>
                    </b-col>
                    <b-col cols=12 class="text-right">
                        <p><a target="_blank" :href="linkSC" class="p-1" style='color: #A7A4A4'>Smart Contracts</a></p>
                    </b-col>
                </b-row>
                <b-row
                  v-for="(item, index) in this.values"
                  v-bind:key="index"
                >
                    <b-col v-if="item.show" cols=12>
                        <div class="legend">
                            <b-col cols=1 class="p-0" style="align-items: center; display: flex;">
                                <div class='icon' :style="{'background-color': item.color}"></div>
                            </b-col>
                            <b-col cols=5 class='pr-0'>
                                <h6 class="mb-0">{{item.name}} <span>{{ (item.percentage*100).toFixed(2) }}%</span></h6>
                            </b-col>
                            <b-col cols=6 class='px-0 text-right color-primary'>
                                <h6 class="mb-0">{{GLOBAL.formatter(GLOBAL._toDecimal(item.value, 9), 2)}} <span> SGBT</span></h6>
                            </b-col>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </b-col>
</template>
<script>
import SmartGlobalIcon from '@/components/icons/SmartGlobalIcon'
export default {
  components: {
    SmartGlobalIcon
  },
  props: [
    'type',
    'dataPieChart',
    'linkSC'
  ],
  data () {
    return {
      canvas: null,
      values: [],
      colors: [
        '#414042',
        '#CFA751',
        '#0a0a0a'
      ],
      movements: [],
      radio: null,
      context: null,
      tamanoDonut: 0
    }
  },
  async created () {
  },
  async mounted () {
    await this.miPastel('myCanvas', 200, 200)
    this.updateWithExtension()
  },
  methods: {
    dibujar (values) {
      var total = 0
      values.forEach(element => {
        total += element.value
      })
      var value = 0
      var color = 0
      var inicioAngulo = 0
      var angulo = 0

      // creamos los quesos del pastel
      for (var i in values) {
        value = values[i].value
        color = values[i].color
        values[i].percentage = total !== 0 ? value / total : 0
        angulo = 2 * Math.PI * values[i].percentage
        console.log('value', values[i])
        this.context.fillStyle = color
        this.context.beginPath()
        this.context.moveTo(this.canvas.width / 2, this.canvas.height / 2)
        this.context.arc(this.canvas.width / 2, this.canvas.height / 2, this.radio, inicioAngulo, (inicioAngulo + angulo))
        this.context.closePath()
        this.context.fill()
        inicioAngulo += angulo
      }
    },
    async miPastel (canvasId, width, height) {
      this.canvas = document.getElementById(canvasId)
      this.canvas.width = width
      this.canvas.height = height
      this.radio = Math.min(this.canvas.width / 2, this.canvas.height / 2)
      this.context = await this.canvas.getContext('2d')
      this.tamanoDonut = 0
    },
    dibujarDonut (tamano, color) {
      this.tamanoDonut = tamano
      this.dibujar(this.values)
      // creamos un circulo del color recibido en medio
      this.context.fillStyle = color
      this.context.beginPath()
      this.context.moveTo(this.canvas.width / 2, this.canvas.height / 2)
      this.context.arc(this.canvas.width / 2, this.canvas.height / 2, this.radio * tamano, 0, 2 * Math.PI)
      this.context.closePath()
      this.context.fill()
    },
    async updateWithExtension () {
      let i = 0
      console.log('console', this.dataPieChart)
      this.values = []
      this.dataPieChart.map(item => {
        this.values.push({
          name: item.name,
          value: item.value,
          color: this.colors[i],
          show: item.show,
          percentage: 0
        })
        ++i
      })
      //
      this.dibujarDonut(0.95, '#282828')
    }
  },
  computed: {
  },
  watch: {
    dataPieChart: function () {
      this.updateWithExtension()
    }
  }
}
</script>

<style scoped>
    .list-group-item .wraper .icon {
        height: 45px;
        width: 45px;
    }
    .legend {
        background-color: #2E2E2E;
        border-radius: 12px;
        padding: 6px;
        margin-bottom: 16px;
        color: white;
        display: flex;
    }
    .legend .icon{
        width: 15px;
        height: 15px;
        border-radius: 50%;
        margin: auto;
    }
</style>
